import React from 'react';
import { token } from '@atlaskit/tokens';

import { OptionSearchMatchMarker, transformToHighligtedParts } from './custom-field-options-search-logic';
export const FieldEditorHighlightedOptionSearchMatch = ({ value, searchMatch }: { value: string | null; searchMatch: OptionSearchMatchMarker }) => {
  const parts = transformToHighligtedParts(value, searchMatch.searchKey);
  return (
    <span>
      {parts.prefix ? parts.prefix : ''}
      {parts.infix ? (
        <span
          style={{
            background: searchMatch.isCurrent ? token('color.background.accent.teal.subtle') : token('color.background.accent.gray.subtler'),
            color: searchMatch.isCurrent ? token('color.text.accent.teal.bolder') : token('color.text.accent.blue.bolder'),
          }}
        >
          {parts.infix}
        </span>
      ) : (
        ''
      )}
      {parts.postfix ? parts.postfix : ''}
    </span>
  );
};
